import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSoldProducts } from "../../../actions/invoiceItem";
import { getAllLocation, getAllLocationPlain } from "../../../actions/warehouseAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllAttributeTerm } from "../../../actions/attributeAction";
import ReactToPrint from "react-to-print";
import dateFormat from "dateformat";
import Excelldownload from "./Excelldownload";
import { Divider, AutoComplete, Row, Col, Select, Skeleton, Button, Layout, DatePicker, Spin, Breadcrumb, TreeSelect } from "antd";

const { RangePicker } = DatePicker;
const { Content } = Layout;
const { Option } = Select;

const SoldPorduct = ({
  getSoldProducts,
  getAllLocation,
  getAllLocationPlain,
  getAllCategory,
  getAllAttributeTerm,
  businessprofile,
  Auth,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setloading] = useState(false);
  const [initial, setinitial] = useState(false);
  const [reload, setreload] = useState(false);
  const location = useRef("");
  const category = useRef("");
  const attributeTerm = useRef("");
  const start = useRef("");
  const end = useRef("");
  const keyward = useRef("");
  const total_quantity = useRef(0);
  const total_amount = useRef(0);
  const total_paid = useRef(0);
  const flag = useRef(0);
  const [attributeTermsList, setAttributeTermsList] = useState([]);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      keyward.current = event.target.value;
    }
  };

  const groupByInvoiceNo = (data) => {
    console.log(data)
    return data.reduce((acc, item) => {
      if (!acc[item.Invoice_no]) {
        acc[item.Invoice_no] = [];
      }
      acc[item.Invoice_no].push(item);
      return acc;
    }, {});
  };

  useEffect(() => {
    total_quantity.current = 0;
    total_amount.current = 0;
    total_paid.current = 0;

    if (categories.length === 0) {
      getAllCategory().then((res) => {
        if (res) setCategories(res);
      });
    }

    if (attributeTermsList.length === 0) {
      getAllAttributeTerm().then((res) => {
        if (res) {
          setAttributeTermsList(res);
        }
      });
    }

    if (flag.current != 0) {
      getAllLocationPlain().then((res) => {
        setLocations(res);
        getSoldProducts(
          keyward.current,
          start.current,
          end.current,
          location.current,
          "",
          category.current,
          attributeTerm.current
        ).then((result) => {
          total_quantity.current = 0;
          total_amount.current = 0;
          total_paid.current = 0;
          if (result) {
            setData(result);
          } else {
            setData([]);
          }
          setloading(false);
        });
      });
    } else {
      setinitial(true);
      getAllLocationPlain().then((res) => {
        setLocations(res);
        setinitial(false);
      });
    }
  }, [reload]);

  const groupedData = groupByInvoiceNo(data);
  console.log(groupedData)

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
        <Breadcrumb.Item>Sold Products Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Row wrap={false}>
          <Col flex="auto">
            <h3>Search by</h3>
            <AutoComplete
              placeholder="product name, barcode, invoice number"
              onKeyUp={onChange}
              style={{ width: "100%", minWidth: "130px" }}
            />
          </Col>
          <Col flex="auto">
            <h3>Issue date :</h3>
            <RangePicker
              style={{ width: "100%" }}
              picker="date"
              onChange={(value) => {
                if (value) {
                  start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                  end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                }
              }}
            />
          </Col>
          <Col flex="auto">
            <h3>Choose warehouse / outlet</h3>
            <Select
              placeholder="Please select a outlet / warehouse"
              style={{ width: "100%" }}
              disabled={
                Auth.superuser ||
                Auth.profile.user_role.id == 10 ||
                Auth.profile.user_role.id == 36 ||
                Auth.profile.user_role.id == 38
                  ? false
                  : true
              }
              onChange={(e) => {
                location.current = e;
              }}
            >
              <Option value="">All</Option>
              {locations.map((outlet) => {
                return <Option value={outlet.id}>{outlet.name}</Option>;
              })}
            </Select>
          </Col>
          <Col flex="auto">
            <h3>Choose category</h3>
            <TreeSelect
              showSearch
              placeholder="Please select a category"
              style={{ width: "100%" }}
              treeDefaultExpandAll
              allowClear
              treeNodeFilterProp="title"
              onChange={(e) => {
                // When clear icon is clicked, e is undefined
                category.current = e !== undefined ? e : "";
              }}
              treeData={[{ title: 'All', value: '', key: 'all' }, ...categories]}
            />
          </Col>
          <Col flex="auto">
            <h3>Choose Size</h3>
            <Select
              allowClear
              placeholder="Please select a size"
              style={{ width: "100%" }}
              onChange={(value) => {
                attributeTerm.current = value !== undefined ? value : "";
              }}
            >
              {attributeTermsList.map((term) => (
                <Option key={term.id} value={term.id}>
                  {term.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col flex="auto">
            <h3>.</h3>
            <Button type="primary" style={{ width: "100%", marginRight: "4px", backgroundColor: "#ab0735" }} onClick={() => {
              flag.current = 1;
              setloading(true);
              setreload(!reload);
            }}>Search</Button>
          </Col>
          <Col flex="auto">
            <h3>.</h3>
            <Excelldownload data={data} />
          </Col>
          <Col flex="auto">
            <h3>.</h3>
            <ReactToPrint
              trigger={() => (
                <Button style={{ marginLeft: "2px", width: "100%" }} type="primary">
                  PDF
                </Button>
              )}
              content={() => componentRef.current}
            />
          </Col>
        </Row>
        <Divider />
        <Spin spinning={loading}>
          <div ref={componentRef} style={{ padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>Sold Products Report</h2>
            <Row>
              <Col span={12} style={{ textAlign: "left" }}>
                {start.current != "" ? (
                  <>
                    From : {dateFormat(start.current, "mmmm dS, yyyy")}
                    <br></br>
                  </>
                ) : (
                  ""
                )}
                {end.current != "" ? (
                  <>
                    To : {dateFormat(end.current, "mmmm dS, yyyy")}
                    <br></br>
                  </>
                ) : (
                  ""
                )}
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                {locations.map((outlet) => {
                  if (outlet.id == location.current)
                    return <>Outlet : {outlet.name}</>;
                })}
              </Col>
            </Row>
            <br></br>
            <table className="attendacne_table" style={{ width: "100%", textAlign: "center" }}>
              <thead>
                <tr style={{ background: "#FAFAFA" }}>
                  <th>SL.</th>
                  <th>Date</th>
                  <th>Invoice</th>
                  <th>Customer Contact</th>
                  {/* <th>Location</th> */}
                  <th>Category</th>
                  <th>SKU</th>
                  <th>Size</th>
                  <th>MRP</th>
                  <th>Quantity</th>
                  <th>Spec Disc</th>
                  <th>Price</th>
                  <th>Total</th>
                  <th>Discount</th>
                  <th>Paid</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(groupedData).map((invoiceNo, index) => {
                  const items = groupedData[invoiceNo];
                  console.log(items)
                  
                    // 🔢 Total calculations for this invoice group
                    let totalInvoicePrice = 0;
                    let totalInvoiceSpecDiscount = 0;
                    let totalInvoiceDiscount = 0;

                    items.forEach(item => {
                      totalInvoicePrice += item.quantity * item.price;
                      totalInvoiceSpecDiscount += parseFloat(item.spec_discount || 0);
                      totalInvoiceDiscount += parseFloat(item.Discount || 0);
                    });

                  return items.map((item, i) => {
                    let product = item.Details.split("--");
                    console.log(product)
                    total_quantity.current += parseInt(item.quantity);
                    total_amount.current += parseInt(item.quantity * item.price);
                    total_paid.current += parseInt(item.quantity * item.price) - parseInt(item.Discount) - parseFloat(item.spec_discount);
                    let product_details = "";
                    let color = "";
                    let size = "";
                    if (product.length > 1) {
                      product_details = product[1].split("/");
                      color = product_details[0];
                      size = product_details.length > 1 ? product_details[1] : "";
                    }
                    return (
                      <tr key={`${invoiceNo}-${i}`}>
                        {i === 0 ? (
                          <>
                            <td rowSpan={items.length}>{index + 1}</td>
                            <td rowSpan={items.length}>{item.issue_date}</td>
                            <td rowSpan={items.length}>{item.Invoice_no}</td>
                            <td rowSpan={items.length}>{item.Contact}</td>
                            {/* <td rowSpan={items.length}>{item.price}</td> */}

                            {/* <td rowSpan={items.length}>
                              {locations.map((outlet) => {
                                if (outlet.id == location.current)
                                  return <>{outlet.name}</>;
                              })}
                            </td> */}
                            
                          </>
                        ) : null}
                        <td>{item.main_category}</td>
                        <td>{product[0]}</td>
                        <td>{color}</td>
                        <td>{item.price}</td>
                        <td>{item.quantity}</td>
                        <td>{item.spec_discount}</td>
                        <td>{(item.price) * (item.quantity)}</td>
                        {/* <td>{(item.price) - parseFloat(item.spec_discount || 0)}</td> */}
                        {i === 0 && (
                          <>
                            <td rowSpan={items.length}>{formatter.format(totalInvoicePrice - totalInvoiceSpecDiscount)}</td>
                            <td rowSpan={items.length}>
                              {/* {formatter.format(totalInvoiceSpecDiscount + totalInvoiceDiscount)} */}
                              {formatter.format(totalInvoiceSpecDiscount + item.Discount)}
                              {/* {item.Discount} */}
                            </td>
                            <td rowSpan={items.length}>
                              {/* {formatter.format(totalInvoicePrice - totalInvoiceSpecDiscount - item.Discount)} */}
                              {parseFloat(item.Payment)}
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  });
                })}
                <tr style={{ background: "#FAFAFA" }}>
                  <td colSpan={7}><b>Total</b></td>
                  <td colSpan={1}></td>
                  <td><b>{total_quantity.current}</b></td>
                  <td colSpan={1}></td>
                  <td><b>{total_amount.current}</b></td>
                  <td colSpan={1}></td>
                  <td colSpan={2}></td>
                  {/* <td><b>{total_paid.current}</b></td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </Spin>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getSoldProducts,
  getAllLocationPlain,
  getAllLocation,
  getAllCategory,
  getAllAttributeTerm,
})(SoldPorduct);